import { Component, OnInit } from '@angular/core';
import {FlashMessageService} from "@shared/partials/flash-message/flash-message.service";
import {partition} from "rxjs";
import {FlashMessage} from "@shared/partials/flash-message/flash-message.models";

@Component({
  selector: 'app-flash-message',
  templateUrl: './flash-message.component.html',
  styleUrls: ['./flash-message.component.scss']
})
export class FlashMessageComponent implements OnInit {

  public flashMessage:FlashMessage|null

  constructor(
    public flashMessageService: FlashMessageService
  ) { }

  ngOnInit(): void {
    this.flashMessageService.showMessage$.subscribe(
      (flashMessage:FlashMessage|null)=>this.flashMessage=flashMessage
    )
  }

  close(){
    this.flashMessageService.hide()
  }

}
